import { z } from 'zod';

const NAME_MIN_LENGTH = 1;
const NAME_MAX_LENGTH = 1024;

export const QConfigEditFormSchema = z.object({
  qConfigName: z
    .string()
    .trim()
    .min(NAME_MIN_LENGTH, {
      message: 'กรุณากรอกชื่อ QConfig',
    })
    .max(NAME_MAX_LENGTH, {
      message: `ความยาวต้องไม่เกิน ${NAME_MAX_LENGTH} ตัวอักษร`,
    }),
  totalQuestions: z.number({
    message: 'กรุณาระบุจำนวนข้อสอบ',
  }),
});

export type QConfigEditFormInput = z.infer<typeof QConfigEditFormSchema>;
